import type { PermissionKey } from '../permissions/index.js';

import type { CompanyAuthSession } from './company-auth-session.dto.js';
import type { BootstrapResponse, CompanyBootstrapResponse } from './bootstrap.dto.js';

export function isCompanyBootstrapResponse(
  bootstrap: BootstrapResponse | null | undefined,
): bootstrap is CompanyBootstrapResponse {
  return bootstrap?.mode === 'company';
}

export function toCompanyAuthSession(bootstrap: CompanyBootstrapResponse): CompanyAuthSession {
  return {
    user: bootstrap.user,
    memberships: bootstrap.memberships,
    activeCompany: bootstrap.activeCompany,
    id: bootstrap.id,
    email: bootstrap.email,
    status: bootstrap.status,
    authzVersion: bootstrap.authzVersion,
    permissions: [...bootstrap.activeCompany.permissions],
  };
}

export function resolveSessionPermissions(
  session: CompanyAuthSession | null | undefined,
): PermissionKey[] {
  if (!session || !session.activeCompany) {
    return [];
  }

  return [...session.activeCompany.permissions];
}

export function hasSessionPermission(
  session: CompanyAuthSession | null | undefined,
  permission: PermissionKey,
): boolean {
  return resolveSessionPermissions(session).includes(permission);
}

export function resolveSessionEnabledFeatures(
  session: CompanyAuthSession | null | undefined,
): string[] {
  if (!session || !session.activeCompany) {
    return [];
  }

  return [...session.activeCompany.enabledFeatures];
}

export function hasSessionFeature(
  session: CompanyAuthSession | null | undefined,
  feature: string,
): boolean {
  return resolveSessionEnabledFeatures(session).includes(feature);
}
